import React                                   from 'react';
import classnames                              from 'classnames';
import { viaFill as defaultOptions } from 'pu-data/SelectOptions';
import { viaFill as tooltip }        from 'pu-data/Tooltips';
import SelectComponent                         from './SelectComponent';

const ViaFill = (props) => {
  const {
    options, parameters, onChangeParameter, groupName, className, label, required,
  } = props;
  const name = 'via_fill';
  const onChange = e => onChangeParameter(name, e.target.value);
  return (
    <SelectComponent
      label={label}
      required={required}
      name={name}
      onChange={onChange}
      options={options}
      tooltip={props.tooltip}
      selected={parameters[name]}
      groupName={groupName}
      className={classnames('material-thickness', className)} />
  );
};

ViaFill.defaultProps = {
  options: defaultOptions,
  label  : 'Filled Vias',
  tooltip,
};

export default ViaFill;
